import mapCategoryTransformer from './mapCategoryTransformer'

const mapDataTransformer = data => ({
    code: data.code,
    error: data.error,
    categories: data?.data?.map(category => mapCategoryTransformer(category)) ?? []
})

export default mapDataTransformer